<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Alur Paxel Big</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Gambar Paxel Big Kiri:"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Gambar Alur Kiri</b>
                  <sup class="text-secondary pl-3">(380 x 280 px) (2 Mb)&nbsp;</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="filePaxelBigLeft"
                    name="imagepaxelbigleft"
                    data-vv-as="Gambar Alur Kiri"
                    v-validate="
                      !items.image_paxel_big_left
                        ? 'required|size:2000|minimalDimensions:380,280|ext:jpg,png,gif,jpeg'
                        : 'size:2000|minimalDimensions:380,280|ext:jpg,png,gif,jpeg'
                    "
                    style="display: none"
                    v-on:change="onChangeFilePaxelBigLeft()"
                  />
                  <b-button
                    @click="$refs.filePaxelBigLeft.click()"
                    v-show="!items.image_paxel_big_left && !filePaxelBigLeft"
                    variant="primary"
                    class="ml-5"
                    >Pilih File</b-button
                  >
                  <b-button
                    v-show="items.image_paxel_big_left || filePaxelBigLeft"
                    variant="primary"
                    @click="modalPaxelBigLeft = !modalPaxelBigLeft"
                    class="mr-2"
                    >Pratinjau</b-button
                  >
                  <b-button
                    @click="$refs.filePaxelBigLeft.click()"
                    v-show="items.image_paxel_big_left || filePaxelBigLeft"
                    variant="outline-primary"
                    class
                    >Ubah File</b-button
                  >
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagepaxelbigleft") }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Gambar Alur Kanan (Bahasa):"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Gambar Alur Kanan (Bahasa)</b>
                  <sup class="text-secondary pl-3">(780 x 400 px)(2 Mb)&nbsp;</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileFlowRightID"
                    name="imageflowrightid"
                    data-vv-as="Gambar Alur Kanan (Bahasa)"
                    v-validate="
                      !items.image_flow_right.id
                        ? 'required|size:2000|minimalDimensions:780,400|ext:jpg,png,gif,jpeg'
                        : 'size:2000|minimalDimensions:780,400|ext:jpg,png,gif,jpeg'
                    "
                    style="display: none"
                    v-on:change="onChangeFileFlowRightID()"
                  />
                  <b-button
                    @click="$refs.fileFlowRightID.click()"
                    v-show="!items.image_flow_right.id && !fileFlowRightID"
                    variant="primary"
                    class="ml-5"
                    >Pilih File</b-button
                  >
                  <b-button
                    v-show="items.image_flow_right.id || fileFlowRightID"
                    variant="primary"
                    @click="modalFlowRightID = !modalFlowRightID"
                    class="mr-2"
                    >Pratinjau</b-button
                  >
                  <b-button
                    @click="$refs.fileFlowRightID.click()"
                    v-show="items.image_flow_right.id || fileFlowRightID"
                    variant="outline-primary"
                    class
                    >Ubah File</b-button
                  >
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imageflowrightid") }}
          </p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Gambar Alur Kanan (English):"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Gambar Alur Kanan (English)</b>
                  <sup class="text-secondary pl-3">(780 x 400 px)(2 Mb)&nbsp;</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileFlowRightEN"
                    name="imageflowrighten"
                    data-vv-as="Gambar Alur Kanan (English)"
                    v-validate="
                      !items.image_flow_right.en
                        ? 'required|size:2000|minimalDimensions:780,400|ext:jpg,png,gif,jpeg'
                        : 'size:2000|minimalDimensions:780,400|ext:jpg,png,gif,jpeg'
                    "
                    style="display: none"
                    v-on:change="onChangeFileFlowRightEN()"
                  />
                  <b-button
                    @click="$refs.fileFlowRightEN.click()"
                    v-show="!items.image_flow_right.en && !fileFlowRightEN"
                    variant="primary"
                    class="ml-5"
                    >Pilih File</b-button
                  >
                  <b-button
                    v-show="items.image_flow_right.en || fileFlowRightEN"
                    variant="primary"
                    @click="modalFlowRightEN = !modalFlowRightEN"
                    class="mr-2"
                    >Pratinjau</b-button
                  >
                  <b-button
                    @click="$refs.fileFlowRightEN.click()"
                    v-show="items.image_flow_right.en || fileFlowRightEN"
                    variant="outline-primary"
                    class
                    >Ubah File</b-button
                  >
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imageflowrighten") }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Gambar Alur Kanan - Mobile (Bahasa):"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Gambar Alur Kanan - Mobile (Bahasa)</b>
                  <sup class="text-secondary pl-3">(420 x 500 px)(2 Mb)&nbsp;</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileFlowRightMobileID"
                    name="imageflowrightmobileid"
                    data-vv-as="Gambar Alur Kanan - Mobile (Bahasa)"
                    v-validate="
                      !items.image_flow_right_mobile.id
                        ? 'required|size:2000|minimalDimensions:420,500|ext:jpg,png,gif,jpeg'
                        : 'size:2000|minimalDimensions:420,500|ext:jpg,png,gif,jpeg'
                    "
                    style="display: none"
                    v-on:change="onChangeFileFlowRightMobileID()"
                  />
                  <b-button
                    @click="$refs.fileFlowRightMobileID.click()"
                    v-show="
                      !items.image_flow_right_mobile.id &&
                      !fileFlowRightMobileID
                    "
                    variant="primary"
                    class="ml-5"
                    >Pilih File</b-button
                  >
                  <b-button
                    v-show="
                      items.image_flow_right_mobile.id || fileFlowRightMobileID
                    "
                    variant="primary"
                    @click="modalFlowRightMobileID = !modalFlowRightMobileID"
                    class="mr-2"
                    >Pratinjau</b-button
                  >
                  <b-button
                    @click="$refs.fileFlowRightMobileID.click()"
                    v-show="
                      items.image_flow_right_mobile.id || fileFlowRightMobileID
                    "
                    variant="outline-primary"
                    class
                    >Ubah File</b-button
                  >
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imageflowrightmobileid") }}
          </p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Gambar Alur Kanan - Mobile (English):"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Gambar Alur Kanan - Mobile (English)</b>
                  <sup class="text-secondary pl-3">(420 x 500 px)(2 Mb)&nbsp;</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileFlowRightMobileEN"
                    name="imageflowrightmobileen"
                    data-vv-as="Gambar Alur Kanan (English)"
                    v-validate="
                      !items.image_flow_right_mobile.en
                        ? 'required|size:2000|minimalDimensions:420,500|ext:jpg,png,gif,jpeg'
                        : 'size:2000|minimalDimensions:420,500|ext:jpg,png,gif,jpeg'
                    "
                    style="display: none"
                    v-on:change="onChangeFileFlowRightMobileEN()"
                  />
                  <b-button
                    @click="$refs.fileFlowRightMobileEN.click()"
                    v-show="
                      !items.image_flow_right_mobile.en &&
                      !fileFlowRightMobileEN
                    "
                    variant="primary"
                    class="ml-5"
                    >Pilih File</b-button
                  >
                  <b-button
                    v-show="
                      items.image_flow_right_mobile.en || fileFlowRightMobileEN
                    "
                    variant="primary"
                    @click="modalFlowRightMobileEN = !modalFlowRightMobileEN"
                    class="mr-2"
                    >Pratinjau</b-button
                  >
                  <b-button
                    @click="$refs.fileFlowRightMobileEN.click()"
                    v-show="
                      items.image_flow_right_mobile.en || fileFlowRightMobileEN
                    "
                    variant="outline-primary"
                    class
                    >Ubah File</b-button
                  >
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imageflowrightmobileen") }}
          </p>
        </b-col>
      </b-row>
      <br />
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="mr-3"
            size="lg"
          >
            Update
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalFlowRightID" title="Preview Image" size="xl">
      <img
        v-show="!fileFlowRightID"
        v-if="items.image_flow_right.id"
        width
        height="400px"
        :src="items.image_flow_right.id"
      />
      <img
        v-show="fileFlowRightID"
        v-if="urlFlowRightID"
        width
        height="400px"
        :src="urlFlowRightID"
      />
    </b-modal>
    <b-modal v-model="modalFlowRightEN" title="Preview Image" size="xl">
      <img
        v-show="!fileFlowRightEN"
        v-if="items.image_flow_right.en"
        width
        height="400px"
        :src="items.image_flow_right.en"
      />
      <img
        v-show="fileFlowRightEN"
        v-if="urlFlowRightEN"
        width
        height="400px"
        :src="urlFlowRightEN"
      />
    </b-modal>
    <b-modal v-model="modalFlowRightMobileID" title="Preview Image" size="xl">
      <img
        v-show="!fileFlowRightMobileID"
        v-if="items.image_flow_right_mobile.id"
        width
        height="400px"
        :src="items.image_flow_right_mobile.id"
      />
      <img
        v-show="fileFlowRightMobileID"
        v-if="urlFlowRightMobileID"
        width
        height="400px"
        :src="urlFlowRightMobileID"
      />
    </b-modal>
    <b-modal v-model="modalFlowRightMobileEN" title="Preview Image" size="xl">
      <img
        v-show="!fileFlowRightMobileEN"
        v-if="items.image_flow_right_mobile.en"
        width
        height="400px"
        :src="items.image_flow_right_mobile.en"
      />
      <img
        v-show="fileFlowRightMobileEN"
        v-if="urlFlowRightMobileEN"
        width
        height="400px"
        :src="urlFlowRightMobileEN"
      />
    </b-modal>
    <b-modal v-model="modalPaxelBigLeft" title="Preview Image" size="xl">
      <img
        v-show="!filePaxelBigLeft"
        v-if="items.image_paxel_big_left"
        width
        height="400px"
        :src="items.image_paxel_big_left"
      />
      <img
        v-show="filePaxelBigLeft"
        v-if="urlPaxelBigLeft"
        width
        height="400px"
        :src="urlPaxelBigLeft"
      />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      items: [],
      loading: false,
      section: "",
      type: null,
      heading_id: "",
      heading_en: "",
      sub_heading_id: "",
      sub_heading_en: "",
      content_id: "",
      content_en: "",
      widthImage: null,
      heightImage: null,
      urlImage: "",
      image: "",
      modalImage: false,
      modalPaxelBigLeft: false,
      modalFlowRightID: false,
      modalFlowRightEN: false,
      modalFlowRightMobileID: false,
      modalFlowRightMobileEN: false,
      filePaxelBigLeft: "",
      fileFlowRightID: "",
      fileFlowRightEN: "",
      fileFlowRightMobileID: "",
      fileFLowRightMobileEN: "",
      urlPaxelBigLeft: "",
      urlFlowRightID: "",
      urlFlowRightEN: "",
      urlFLowRightMobileID: "",
      urlFLowRightMobileEN: "",
      options1: [
        { text: "Tidak", value: false },
        { text: "Ya", value: true },
      ],
    };
  },
  beforeCreate() {
    this.$store.dispatch("FlowModule/getFlow");
  },
  created() {
    this.$store.watch(
      (state) => state.FlowModule.flow_id,
      (newValue, oldValue) => {
        this.items = newValue;
      }
    );
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("image_paxel_big_left", this.filePaxelBigLeft);
          formData.append("image_flow_right_id", this.fileFlowRightID);
          formData.append("image_flow_right_en", this.fileFlowRightEN);
          formData.append(
            "image_flow_right_mobile_id",
            this.fileFlowRightMobileID
          );
          formData.append(
            "image_flow_right_mobile_en",
            this.fileFlowRightMobileEN
          );
          this.$store
            .dispatch("FlowModule/postFlow", formData)
            .then((response) => {
              this.loading = false;
              this.$validator.reset();
              this.$router.push({ name: "FlowBig" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your file cant be submit.", "warning");
        }
      });
    },
    onChangeFilePaxelBigLeft() {
      this.filePaxelBigLeft = this.$refs.filePaxelBigLeft.files[0];
      const input = this.$refs.filePaxelBigLeft;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlPaxelBigLeft = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileFlowRightID() {
      this.fileFlowRightID = this.$refs.fileFlowRightID.files[0];
      const input = this.$refs.fileFlowRightID;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlFlowRightID = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileFlowRightEN() {
      this.fileFlowRightEN = this.$refs.fileFlowRightEN.files[0];
      const input = this.$refs.fileFlowRightEN;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlFlowRightEN = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileFlowRightMobileID() {
      this.fileFlowRightMobileID = this.$refs.fileFlowRightMobileID.files[0];
      const input = this.$refs.fileFlowRightMobileID;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlFlowRightMobileID = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileFlowRightMobileEN() {
      this.fileFlowRightMobileEN = this.$refs.fileFlowRightMobileEN.files[0];
      const input = this.$refs.fileFlowRightMobileEN;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlFlowRightMobileEN = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  },
};
</script>

<style>
</style>
